export default __webpack_public_path__ + "static/media/jcb.3b89c973.png";